import React from "react";

function OutlookReplyButton({
  to = "",
  cc = "",
  bcc = "",
  subject = "",
  body = "",
  buttonText = "Reply",
  className = "",
  children
}) {
  const handleReply = () => {
    // Encode the email components for URL safety
    const encodedTo = encodeURIComponent(to);
    const encodedCC = cc ? encodeURIComponent(cc) : "";
    const encodedBCC = bcc ? encodeURIComponent(bcc) : "";
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);

    // Build the mailto URL
    let mailtoUrl = `mailto:${encodedTo}?`;
    
    const params = [];
    if (encodedCC) params.push(`cc=${encodedCC}`);
    if (encodedBCC) params.push(`bcc=${encodedBCC}`);
    if (encodedSubject) params.push(`subject=${encodedSubject}`);
    if (encodedBody) params.push(`body=${encodedBody}`);
    
    mailtoUrl += params.join('&');

    // Open the default email client
    window.location.href = mailtoUrl;
  };

  const defaultClassName = "px-4 py-2 bg-primary text-white rounded hover:bg-red-700 transition-colors duration-200 font-medium";

  return (
    <button
      onClick={handleReply}
      className={className || defaultClassName}
      type="button"
    >
      {children || buttonText}
    </button>
  );
}

export default OutlookReplyButton;